import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
}
const baseClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-navy-dark bg-gold border-2 border-gold-dark rounded-full shadow-[0_8px_24px_rgba(14,37,71,0.22)] hover:bg-gold-light hover:shadow-[0_10px_30px_rgba(212,169,58,0.4)] transition-[background-color,box-shadow] duration-200 ease-smooth focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-ivory';
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  onLinkClick,
  ...props
}: ButtonProps) {
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} transition={{
      duration: 0.16,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-60" data-mp="30sbdwbd7rico">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.16,
    ease: [0.23, 1, 0.32, 1]
  }} {...props} data-id="element-61" data-mp="8agw10fr5saw">
      {children}
    </motion.button>;
}